// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".required[data-v-5108b5c5]:after{content:\" *\";color:red}.p-card[data-v-5108b5c5]{box-shadow:none}.p-dialog .p-card .p-card-body[data-v-5108b5c5]{padding:0!important}.break-line[data-v-5108b5c5]{white-space:break-spaces}", ""]);
// Exports
module.exports = exports;
